import { BaseAPI } from "./base-api";

export interface ConfirmMatchDto {
  safeleaseLocationId: number;
  cubbyFacilityId: number;
}

class LocationMatchingAPI extends BaseAPI {
  constructor() {
    super();
  }

  async getUnmatchedRelationships() {
    const response = await this.axiosInstance.get("/api/location-matching/unmatched-relationships");
    return response.data;
  }

  async getUnmatchedLocations() {
    const response = await this.axiosInstance.get("/api/location-matching/unmatched-locations");
    return response.data;
  }

  async getCubbyFacilities(relationshipId: number | string) {
    const response = await this.axiosInstance.get(`/api/location-matching/cubby-facilities/${relationshipId}`);
    return response.data;
  }

  async confirmMatch(dto: ConfirmMatchDto) {
    const response = await this.axiosInstance.post(`/api/location-matching/confirm-match`, dto);
    return response.data;
  }
}

export const locationMatchingApi = new LocationMatchingAPI();
